let removedOnce = false

const removeInitialLoader = ():void => {
  if (removedOnce) return
  const loader = <HTMLElement>document.querySelector('.aha-logo-loader')
  if (loader) {
    loader.remove()
    removedOnce = true
  }
}

export default removeInitialLoader
